import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Bell, Settings, CheckCircle, AlertTriangle, DollarSign, FileText, Calendar, Clock, MoreHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';
const TABS = ['All', 'Approvals', 'Conflicts', 'Finance', 'Contracts', 'Schedule'];
const NOTIFICATIONS = [{
  id: 1,
  type: 'Contracts',
  title: 'Contract awaiting signature',
  objectName: 'The Empty Bottle',
  urgency: 'medium',
  color: 'text-amber-500',
  bg: 'bg-amber-500/10',
  icon: FileText,
  time: '10m ago',
  action: 'Review Contract'
}, {
  id: 2,
  type: 'Conflicts',
  title: 'Lineup conflict',
  objectName: 'Jun 14 Cleveland',
  urgency: 'high',
  color: 'text-red-500',
  bg: 'bg-red-500/10',
  icon: AlertTriangle,
  time: '1h ago',
  action: 'Resolve Conflict'
}, {
  id: 3,
  type: 'Finance',
  title: 'Deposit overdue',
  objectName: 'Higher Ground',
  urgency: 'high',
  color: 'text-red-500',
  bg: 'bg-red-500/10',
  icon: DollarSign,
  time: '2h ago',
  action: 'Send Reminder'
}, {
  id: 4,
  type: 'Approvals',
  title: 'Offer received',
  objectName: 'The Sinclair — $2,500',
  urgency: 'medium',
  color: 'text-amber-500',
  bg: 'bg-amber-500/10',
  icon: CheckCircle,
  time: '3h ago',
  action: 'Review Offer'
}, {
  id: 5,
  type: 'Schedule',
  title: 'Show advance incomplete',
  objectName: 'Jun 22',
  urgency: 'low',
  color: 'text-blue-500',
  bg: 'bg-blue-500/10',
  icon: Calendar,
  time: '5h ago',
  action: 'Complete Advance'
}, {
  id: 6,
  type: 'Contracts',
  title: 'Counter-signed contract received',
  objectName: 'Lincoln Hall',
  urgency: 'low',
  color: 'text-green-500',
  bg: 'bg-green-500/10',
  icon: FileText,
  time: '1d ago',
  action: 'View Contract'
}, {
  id: 7,
  type: 'Finance',
  title: 'Settlement ready for review',
  objectName: 'Metro Chicago',
  urgency: 'medium',
  color: 'text-amber-500',
  bg: 'bg-amber-500/10',
  icon: DollarSign,
  time: '1d ago',
  action: 'Review Settlement'
}, {
  id: 8,
  type: 'Approvals',
  title: 'Hold challenged',
  objectName: 'Bowery Ballroom',
  urgency: 'high',
  color: 'text-red-500',
  bg: 'bg-red-500/10',
  icon: Clock,
  time: '2d ago',
  action: 'Confirm or Release'
}];
export function NotificationsPage() {
  const [activeTab, setActiveTab] = useState('All');
  const filteredNotifications = activeTab === 'All' ? NOTIFICATIONS : NOTIFICATIONS.filter(n => n.type === activeTab);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-5xl mx-auto space-y-6" data-id="element-4059">
      <div className="flex items-center justify-between" data-id="element-4060">
        <div data-id="element-4061">
          <h1 className="text-2xl font-bold text-zinc-100" data-id="element-4062">Notifications</h1>
          <p className="text-zinc-400" data-id="element-4063">Stay on top of your tasks and alerts.</p>
        </div>
        <Link to="/app/settings" className="flex items-center space-x-2 text-sm text-zinc-400 hover:text-zinc-100 transition-colors" data-id="element-4064">
          <Settings className="w-4 h-4" data-id="element-4065" />
          <span data-id="element-4066">Notification Settings</span>
        </Link>
      </div>

      <div className="flex space-x-1 border-b border-zinc-800 overflow-x-auto no-scrollbar" data-id="element-4067">
        {TABS.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-amber-500 text-amber-500' : 'border-transparent text-zinc-400 hover:text-zinc-100 hover:border-zinc-700'}`} data-id="element-4068">
            {tab}
          </button>)}
      </div>

      <div className="space-y-3" data-id="element-4069">
        {filteredNotifications.length > 0 ? filteredNotifications.map(notification => <div key={notification.id} className="flex items-center justify-between p-4 bg-[#14141A] border border-zinc-800 rounded-xl hover:border-zinc-700 transition-colors group" data-id="element-4070">
              <div className="flex items-start space-x-4" data-id="element-4071">
                <div className={`p-2 rounded-lg ${notification.bg}`} data-id="element-4072">
                  <notification.icon className={`w-5 h-5 ${notification.color}`} data-id="element-4073" />
                </div>
                <div data-id="element-4074">
                  <div className="flex items-center space-x-2" data-id="element-4075">
                    <h3 className="text-zinc-100 font-medium" data-id="element-4076">
                      {notification.title}
                    </h3>
                    <span className="text-zinc-500 text-sm" data-id="element-4077">•</span>
                    <span className="text-zinc-400 text-sm" data-id="element-4078">
                      {notification.time}
                    </span>
                  </div>
                  <p className="text-zinc-400 text-sm mt-1" data-id="element-4079">
                    Related to:{' '}
                    <span className="text-zinc-300 font-medium" data-id="element-4080">
                      {notification.objectName}
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-3 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-4081">
                <button className="px-4 py-2 text-sm font-medium text-zinc-900 bg-amber-500 hover:bg-amber-400 rounded-lg transition-colors" data-id="element-4082">
                  {notification.action}
                </button>
                <button className="p-2 text-zinc-400 hover:text-zinc-100 bg-zinc-800/50 hover:bg-zinc-800 rounded-lg transition-colors" data-id="element-4083">
                  <MoreHorizontal className="w-4 h-4" data-id="element-4084" />
                </button>
              </div>
            </div>) : <div className="py-12 text-center bg-[#14141A] border border-zinc-800 rounded-xl" data-id="element-4085">
            <Bell className="w-12 h-12 text-zinc-600 mx-auto mb-4" data-id="element-4086" />
            <h3 className="text-lg font-medium text-zinc-100 mb-1" data-id="element-4087">
              All caught up!
            </h3>
            <p className="text-zinc-400" data-id="element-4088">No notifications in this category.</p>
          </div>}
      </div>
    </motion.div>;
}